import { render, staticRenderFns } from "./dialog-setting-erp.vue?vue&type=template&id=520052a5"
import script from "./dialog-setting-erp.vue?vue&type=script&lang=js"
export * from "./dialog-setting-erp.vue?vue&type=script&lang=js"
import style0 from "./dialog-setting-erp.vue?vue&type=style&index=0&id=520052a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports